<div id="assign-modal">
    <div class="modal-header">
        <h2 class="title">
            <app-icon type="AssignClass" class="assign-class-icon"></app-icon>Assign to Class
        </h2>
        <div class="close" (click)="closeModal()">
            <app-icon [type]="'ThinCross'"></app-icon>
        </div>
    </div>
    <div class="modal-body">
        <ng-container *ngIf="step === 1">
            <app-select-class-view
                [activeModal]="activeModal"
                [rosters]="rosters"
                [assignmentCode]="assignmentCode"
                [assignmentName]="assignmentName"
                [assignmentHasLti]="assignmentHasLti"
                [type]="type"
                (step)="stepChange($event)"
            ></app-select-class-view>
        </ng-container>
        <ng-container *ngIf="step === 2">
            <app-select-student-view
                [rosters]="rosters"
                (step)="stepChange($event)"
            ></app-select-student-view>
        </ng-container>
        <ng-container *ngIf="step === 3">
            <app-loading-view
                [loading]="loading"
                [error]="error"
                (resendRequest)="resendRequest()"
            ></app-loading-view>
        </ng-container>
        <ng-container *ngIf="step === 4">
            <app-review-assignments-view
                [activeModal]="activeModal"
                [assignmentCode]="assignmentCode"
                [assignmentName]="assignmentName"
                [rosters]="rosters"
            ></app-review-assignments-view>
        </ng-container>
    </div>
</div>
